function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.7925 89.1166L232 43.5908L205.871 108.06C204.238 112.032 204.442 116.412 206.177 120.18L228.53 167.845L90.4322 201.964C76.8572 205.325 63.7925 195.038 63.7925 181.187V89.1166Z",
  fill: "#000C28"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M86.5538 189.233L209.545 158.78L193.113 123.643C190.357 117.838 190.255 111.116 192.602 105.209L209.545 63.4512L77.1636 99.3015V181.798C77.1636 186.788 81.7566 190.353 86.5538 189.233Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M178.516 22.9157C178.516 10.2866 168.208 0 155.551 0C153.51 0 151.366 0.305542 149.325 0.81478L18.5763 37.1743V25.9711C18.5763 25.7674 18.5763 25.5637 18.5763 25.36C21.5363 23.2212 23.4756 19.7584 23.4756 15.8882C23.4756 9.47181 18.2701 4.17575 11.7378 4.17575C5.20546 4.17575 0 9.47181 0 15.8882C0 19.7584 1.93929 23.2212 4.89925 25.36C4.89925 25.5637 4.89925 25.7674 4.89925 25.9711V210.111C4.89925 213.88 7.96129 216.935 11.7378 216.935C15.5143 216.935 18.5763 213.88 18.5763 210.111V176.705L76.1425 161.021C86.9617 160.002 101.864 160.104 117.684 165.197C134.934 170.798 145.957 172.428 152.387 172.733C153.306 172.835 154.326 172.937 155.347 172.937C168.208 172.937 178.516 162.549 178.516 149.818C178.516 149.614 178.516 149.308 178.516 149.105V22.9157Z",
  fill: "#000C28"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5762 162.956L130.749 132.402C133.096 131.791 135.546 131.281 137.995 131.078L141.67 130.67C147.896 130.059 154.122 130.365 160.246 131.689L165.145 132.707V22.9157C165.145 16.6011 159.123 11.9162 152.897 13.6476L18.5762 51.0256V162.956Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 65.4557,
  y1: 146.145,
  x2: 365.752,
  y2: 61.7368,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0069D2",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0069D2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 5.61362,
  y1: 111.523,
  x2: 341.324,
  y2: 23.5792,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0069D2",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0069D2"
})));

var SvgMilestoneBadge = function SvgMilestoneBadge(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 217,
    viewBox: "0 0 232 217",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMilestoneBadge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/milestone-badge.d74c58ff.svg";
export { ForwardRef as ReactComponent };